import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { SystemSettingsProvider } from './context/SystemSettingsContext';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import './App.css';

// Import page components (will be created)
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import DrinkDetailPage from './pages/DrinkDetailPage';
import CartPage from './pages/CartPage';
import AuthPage from './pages/AuthPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ProfilePage from './pages/ProfilePage';
import OrdersPage from './pages/OrdersPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import RefundPage from './pages/RefundPage';
import ReturnPage from './pages/ReturnPage';
import ShippingPage from './pages/ShippingPage';

function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <SystemSettingsProvider>
          <CartProvider>
            <Router>
            <div className="App">
              <Navbar />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/menu" element={<MenuPage />} />
                  <Route path="/drink/:id" element={<DrinkDetailPage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/auth" element={<AuthPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/orders" element={<OrdersPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/refund" element={<RefundPage />} />
                  <Route path="/returns" element={<ReturnPage />} />
                  <Route path="/shipping" element={<ShippingPage />} />
                </Routes>
              </main>
              <Footer />
            </div>
            </Router>
          </CartProvider>
        </SystemSettingsProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
